'use client';

import { ReactNode, Ref, forwardRef, useEffect, useRef, useState } from "react";
import { Swiper as SwiperJS, SwiperProps, SwiperSlideProps } from 'swiper/react';
import { SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { twMerge } from 'tailwind-merge';
import {useOverflow} from 'use-overflow';
import HomeArrow from "@/app/components/svg/HomeArrow";

interface Props {
  id: string;
  slides: ReactNode[];
  className?: string;
  wrapperClassName?: string;
  swiperProps?: Partial<SwiperProps>;
  swiperSlideProps?: Partial<SwiperSlideProps>;
}

const Swiper = ({ slides, className, wrapperClassName, swiperProps, swiperSlideProps, id }: Props) => {
  const ref = useRef<any>();
      const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);
    const [selected,setSelected] = useState(0);
    const itemsLength = slides.length;
  return (
    <div className={twMerge('flex flex-col w-full h-full gap-y-[16px] desktop:gap-y-0 desktop:px-[16px] relative', wrapperClassName)}>
      <SwiperJS
        // dir='rtl'
        modules={[Pagination]}
        uniqueNavElements={false}
        slidesPerView={1}
        breakpoints={{
          0: {
            slidesPerView: 1
          },
          768: {
            slidesPerView: 3
          }
        }}
           pagination={
          {
            dynamicBullets: true,
            dynamicMainBullets: 1,
            el: `.swiper-custom-pagination-${id}`,
            type: 'bullets',
            clickable: true,
            // bulletActiveClass: 'bg-secondary',
            bulletClass: `swiper-pagination-bullet-${id}`,
          }
        }
        style={{
          // @ts-ignore
          "--swiper-navigation-color": "black",
          "--swiper-navigation-size": "30px",
        }}
                onSlideChange={() => {
          const swiper = ref.current?.swiper;
          setIsBeginning(swiper.isBeginning);
          setIsEnd(swiper.isEnd);
        }}
        onInit={() => {
          const swiper = ref?.current?.swiper;
          console.log({swiper});
          if (swiper) {
            setIsBeginning(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
            // swiper.autoplay.stop();
            // setTimeout(() => swiper.autoplay?.start(), 6000)
          }
          // setInit(true);
        }}
        {...swiperProps}

        className={twMerge('w-full !relative', swiperProps?.className)}
        wrapperClass={twMerge(className)}
        ref={ref}
      >
        {slides.map((s, i) => <SwiperSlide key={i} {...swiperSlideProps} className={twMerge('h-full [&>*]:h-full tablet:pl-[24px] pb-[10px] desktop:pb-0', swiperSlideProps?.className)}>{s}</SwiperSlide>)}
      </SwiperJS>
<div className={`!h-[25px] !w-full !flex !items-center [&>*]:!scale-100 [&>*]:opacity-50 [&>.swiper-pagination-bullet-active]:!opacity-100 [&>.swiper-pagination-bullet-active]:!bg-primary [&>.swiper-pagination-bullet-active]:!h-[12px] [&>.swiper-pagination-bullet-active]:!w-[12px] !justify-center [&>*]:!bg-gray-400 dark:[&>*]:!bg-white [&>*]:!h-[6px] [&>*]:!w-[6px] [&>*]:aspect-square gap-x-[24px] [&>*]:rounded-full swiper-custom-pagination-${id}`}></div> 

      <div 
  onClick={() => {
    if (isEnd) return;
    ref.current?.swiper?.slideNext();
    let newIndex = selected! + 1;
    if (newIndex >= itemsLength) {
      newIndex = 0;
    }
    setSelected(newIndex);
  }}
  className={twMerge(
    'absolute desktop:hidden left-[16px] desktop:left-[-50px] top-[40%] translate-y-[-50%] h-[72px] w-fit grid place-items-center cursor-pointer z-[2]',
    isEnd && '!hidden'
  )}
>
  <HomeArrow className='h-[72px] w-[72px]'/>
</div>

<div 
  onClick={() => {
    if (isBeginning) return;
    ref.current?.swiper?.slidePrev();
    setSelected((selected || 1) - 1)
  }}
  className={twMerge(
    'absolute desktop:hidden right-[16px] desktop:left-[-50px] top-[40%] translate-y-[-50%] h-[72px] w-fit grid place-items-center cursor-pointer z-[2] rotate-180',
    isBeginning && '!hidden'
  )}
>
  <HomeArrow className='h-[72px] w-[72px]'/>
</div>

 </div>

)
};


export default Swiper;